import React from 'react';

function Standard2(){
    return(
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" id="standard" viewBox="0 0 124.6 122">

<g id="standard2">
	<polygon className="st8" points="28.5,61 41.4,65.6 48.6,78.4 62,73.1 74.8,78 81.7,66.3 95.2,61.2 93,45.5 100.5,34.6 89.1,25.4 
		87.2,11.5 71.5,11.3 62.3,2.3 52.1,11 36.6,11.5 34.8,26.4 23.7,34.4 31.2,46.2 	"/>
	<path className="st8" d="M34.7,69.9v48.3h6.9L58.4,101V81.6l-10.9,4.7c0,0-2,0.6-3.3-1.3L34.7,69.9z"/>
	<path className="st8" d="M89.7,70.3v48.3h-6.9L66,101.4V82l10.9,4.7c0,0,2,0.6,3.3-1.3L89.7,70.3z"/>
	<polygon className="st9" points="55.5,53 76.9,36.1 72.2,30.9 57.4,42.4 52.6,37.1 47.3,41.3 46.8,41.8 	"/>
</g>
</svg>

    )
}

export default Standard2;